module.exports = __webpack_public_path__ + "media/images/photo/plans/common/img_engagement-location-photo-fd51c720b66a9b21fc2b1be81ebba1f6.png";